import BaseServiceHttp from '../baseService'
class Metas extends BaseServiceHttp {
  constructor(id) {
    const resource = 'metas'
    const relationship = {}
    const baseURL = process.env.REACT_APP_API_URL
    super(id, resource, relationship, baseURL)
  }
}

export default id => new Metas(id)
